import { NO_VALUE_PLACEHOLDER } from "shared/constants/appConstants";
import { AddressesLookup } from "shared/models/spaceStone/lookup/addressesLookup";

function formatAddress(address: AddressesLookup): string {
    if (!address.addressLine1 && !address.addressLine2 && !address.city && !address.postcode) {
        return NO_VALUE_PLACEHOLDER;
    }

    return address.addressLine2
        ? `${address.addressLine1}, ${address.addressLine2}, ${address.city}, ${
              address.country ? address.country.text : NO_VALUE_PLACEHOLDER
          }, ${address.postcode}`
        : `${address.addressLine1}, ${address.city}, ${
              address.country ? address.country.text : NO_VALUE_PLACEHOLDER
          }, ${address.postcode}`;
}

export default formatAddress;

export function formatAddressWithoutCountry(address: AddressesLookup): string {
    if (!address.addressLine1 && !address.addressLine2 && !address.city && !address.postcode) {
        return NO_VALUE_PLACEHOLDER;
    }

    return address.addressLine2
        ? `${address.addressLine1}, ${address.addressLine2}, ${address.city}, ${address.postcode}`
        : `${address.addressLine1}, ${address.city}, ${address.postcode}`;
}

const joinAddressItems = (...addressItems: (string | undefined | null)[]): string =>
    addressItems.filter(it => !!it).join(", ");

export const getFullAddress = ({ postcode, city, addressLine1, addressLine2, country }: AddressesLookup): string =>
    joinAddressItems(addressLine1, addressLine2, city, country?.text, postcode);

export const getFullAddressWithoutCountry = ({ postcode, city, addressLine1, addressLine2 }: AddressesLookup): string =>
    joinAddressItems(postcode, city, addressLine1, addressLine2);

export const isPossibleAddressLookup = (obj: Record<string, unknown> | unknown): obj is AddressesLookup => {
    if (!obj || typeof obj !== "object" || obj === null) return false;

    if ("addressLine1" in obj || "addressLine2" in obj || "city" in obj || "postcode" in obj) return true;

    return false;
};
